import React from 'react';
import Lottie from 'react-lottie';
import './Point_Down_Lottie.css';
import * as animationData from './Point_Down_Lottie.json';

function Point_Down_Lottie(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <section className='main'>
            <div className='Point_Down_Lottie_icon'>
                <Lottie className="me-auto"
                options={defaultOptions}         
                />       
        </div>
      </section>
    );
}
export default Point_Down_Lottie;